import type { LicenseStatus } from 'archive/types';

export const licenseIsLoading = (license: LicenseStatus) => license.loading;
export const isValidLicense = (license: LicenseStatus) => license && !license.missing && (license.status && license.status.valid);
